import { START_LOCATION, type RouteLocationNormalized } from 'vue-router'

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
  }
}

/**
 * The base snippet in index.html already fires PageView on the full load, so
 * the initial navigation and query/hash-only changes are skipped here.
 * fbevents.js may also auto-track history.pushState (a per-pixel setting in
 * Events Manager) and dedupes a repeated PageView for the same URL, so this
 * hook only matters when that setting is off.
 */
export function shouldTrackMetaPixelPageView(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
): boolean {
  if (from === START_LOCATION) return false
  return to.path !== from.path
}

export function trackMetaPixelPageView(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
): void {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return
  if (!shouldTrackMetaPixelPageView(to, from)) return
  window.fbq('track', 'PageView')
}
